// src/js/components/skins/license-expired.js
export class LicenseExpiredSkin {
  htmlskin() {
    return `
      <div class="license-expired-container">
        <div class="expired-card">
          <div class="expired-icon">
            <span class="iconify" data-icon="mdi:alert-circle-outline" data-inline="false"></span>
          </div>
          <h1 class="expired-title">License Expired</h1>
          <p class="expired-message">
            This user's license has expired. Please contact info@lapomikenergy.com to renew your license and regain access.
          </p>
          <div class="expired-actions">
            <button id="retryLogin" class="retry-button">Back to Login</button>
            <button id="contactSupport" class="contact-button">Contact Support</button>
          </div>
        </div>
      </div>
    `;
  }
}
